<template>
<!--    <BasicLayout>-->
        <el-container>
            <el-aside width="240px">
<!--                <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==1}" @click.native="region"><span :class="{ico1:true,ico1A:active===1}"></span><span>组织架构</span></el-row>-->
<!--                <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==1}" @click.native="region"><span :class="{ico1:true,ico1A:active===1}"></span><span>组织架构</span></el-row>-->
<!--                <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==2}" @click.native="region2"><span :class="{ico2:true,ico2A:active===2}"></span><span>角色与权限</span></el-row>-->
<!--                <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==4}" @click.native="region4"><span :class="{ico4:true,ico4A:active===4}"></span><span>资料库</span></el-row>-->
                <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==3}" @click.native="region3"><span :class="{ico3:true,ico3A:active===3}"></span><span>数据字典</span></el-row>
                <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==5}" @click.native="region5"><span :class="{ico5:true,ico5A:active===5}"></span><span>系统参数</span></el-row>
                <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==6}"
                        @click.native="region6"><span :class="{ico6:true,ico6A:active===6}"></span><span>功能菜单[手机端]
                </span></el-row>
<!--                <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==7}"-->
<!--                        @click.native="region7"><span :class="{ico7:true,ico7A:active===7}"></span><span>功能菜单[PC端]-->
<!--                </span></el-row>-->
<!--                <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==6}" @click.native="region6"><span :class="{ico6:true,ico6A:active===6}"></span><span>产品管理</span></el-row>-->
                <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==8}"
                        @click.native="region8"><span :class="{ico8:true,ico8A:active===8}"></span><span>自定义字段
                </span></el-row>
                <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==9}"
                        @click.native="region9"><span :class="{ico9:true,ico9A:active===9}"></span><span>任务管理
                </span></el-row>
            </el-aside>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
<!--    </BasicLayout>-->
</template>

<script>
    import axios from 'axios'
    import http from '../../APIService/http'
    // import BasicLayout from "../../components/navHeader";
    import  {bus} from '../../router/index'

    export default {
        name: "index",
        components:{
            // BasicLayout
        },
        data(){
            return {
                active:3,
            }
        },
        methods:{
            region(){
                this.$router.push({
                    path:'/systemDevelop/regionDevelop'
                })
                this.active=1

            },
            region2(){
                this.$router.push({
                    path:'/systemDevelop/limitsDevelop'
                })
                this.active=2

            },
            region3(){
                this.$router.push({
                    path:'/systemDevelop/dictionaryDevelop'
                })
                this.active=3
            },
            region4(){
                    this.$router.push({
                    path:'/systemDevelop/dataHomeDevelop'
                    })
                this.active=4
                },
            region5(){
                    this.$router.push({
                        path:'/systemDevelop/parametersDevelop'
                    })
                this.active=5
            },
            region6(){
                this.$router.push({
                    path:'/systemDevelop/phonemenu'
                })
                this.active=6
            },
            region7(){
                this.$router.push({
                    path:'/systemDevelop/pcmenu'
                })
                this.active=7
            },
            region8(){
                this.$router.push({
                    path:'/systemDevelop/custom'
                })
                this.active=8
            },
            region9(){
                this.$router.push({
                    path:'/systemDevelop/developTaskManage'
                })
                this.active=9
            },
        },
        created() {
            bus.$on('active',a=>this.active=a)
            this.$router.push({
                path:'/systemDevelop/dictionaryDevelop'
            })
            this.active=3
            // this.bb()
        }
    }
</script>

<style scoped>
    .el-aside{
        background: #F4F6F8;
        padding: 30px 0;
        /*border: 1px solid #DCDFE6;*/
    }
    .el-main{
        background: white;
        /*border: 1px solid #DCDFE6;*/
        border-left: none;
        padding: 34px 20px;
        padding-bottom: 20px;
        box-sizing: border-box;
    }
    .options{
        cursor: pointer;
        height: 60px;
        font-family: 'Hiragino Sans GB';
        font-size: 16px;
        color: #323232;
        padding-left:40px ;
        user-select: none;
    }

    .ico1:before{

        content: '';
        display: inline-block;
        width: 20px;
        height: 20px;
        text-align: center;
        background: url("../../assets/images/Fill2.png") no-repeat center;
        margin-right:20px ;
        background-size: cover;
    }
    .ico2:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        background: url("../../assets/images/ico1.png") no-repeat center;
        margin-right:20px ;
        background-size: contain;
    }
    .ico3:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        background: url("../../assets/images/diction1.png") no-repeat center;
        margin-right:20px ;
        background-size: contain;
    }
    .ico4:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        background: url("../../assets/images/dataBank2.png") no-repeat center;
        margin-right:20px ;
        background-size: contain;
    }
    .ico5:before{
            content: '';
            display: inline-block;
            width: 22px;
            height: 22px;
            text-align: center;
            background: url("../../assets/images/systemParameter1.png") no-repeat center;
            margin-right:20px ;
            background-size: contain;
        }
    .ico6:before{
        content: '';
        display: inline-block;
        width: 18px;
        height: 18px;
        text-align: center;
        background: url("../../assets/images/menuphone.png") no-repeat center;
        margin-right:20px ;
        background-size: contain;
    }
    .ico7:before{
        content: '';
        display: inline-block;
        width: 18px;
        height: 18px;
        text-align: center;
        background: url("../../assets/images/menupc.png") no-repeat center;
        margin-right:20px ;
        background-size: contain;
    }
    .ico8:before{
        content: '';
        display: inline-block;
        width: 18px;
        height: 18px;
        text-align: center;
        background: url("../../assets/images/custom1.png") no-repeat center;
        margin-right:20px ;
        background-size: contain;
    }
    .ico9:before{
        content: '';
        display: inline-block;
        width: 18px;
        height: 18px;
        text-align: center;
        background: url("../../assets/images/task1.png") no-repeat center;
        margin-right:20px ;
        background-size: contain;
    }
   /* .options:hover{
        color: white;
        background: #409EFF;
    }
    .options:hover .ico1:before{
        background: url("../../assets/images/Fill1.png") no-repeat center;
    }
    .options:hover .ico2:before{
        background: url("../../assets/images/ico2.png") no-repeat center;
    }*/
    .optionsActive{
        cursor: pointer;
        height: 60px;
        font-family: Hiragino Sans GB;
        font-size: 16px;
        color: #323232;
        padding-left:40px ;
        user-select: none;
        color: white;
        background: #409EFF;
    }
    .ico1A:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/Fill1.png") no-repeat center;
        background-size: contain;
    }
    .ico2A:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/ico2.png") no-repeat center;
        background-size: contain;
    }
    .ico3A:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/diction2.png") no-repeat center;
        background-size: contain;
    }
    .ico4A:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/dataBank1.png") no-repeat center;
        background-size: contain;
    }
    .ico5A:before{
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/systemParameter2.png") no-repeat center;
        background-size: contain;
    }
    .ico6A:before{
        content: '';
        display: inline-block;
        width: 18px;
        height: 18px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/menuphoneactive.png") no-repeat center;
        background-size: contain;
    }
    .ico7A:before{
        content: '';
        display: inline-block;
        width: 18px;
        height: 18px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/menupcactive.png") no-repeat center;
        background-size: contain;
    }
    .ico8A:before{
        content: '';
        display: inline-block;
        width: 18px;
        height: 18px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/custom2.png") no-repeat center;
        background-size: contain;
    }
    .ico9A:before{
        content: '';
        display: inline-block;
        width: 18px;
        height: 18px;
        text-align: center;
        margin-right:20px ;
        background: url("../../assets/images/task.png") no-repeat center;
        background-size: contain;
    }
    .el-container{
        min-height: 100%;
        padding:0;
    }

</style>



// WEBPACK FOOTER //
// src/pages/develop/index.vue